import React from 'react';
import { Outlet } from 'react-router';

const ProjectGalleryLayout = () => (
  <>
    <Outlet />
  </>
);

export default ProjectGalleryLayout;
